import { SkuLayoutProps } from '@/types/other';
import SEO_Cookiebot from '../scripts/seo_cookiebot';
import Head from 'next/head';
import { useRouter } from 'next/router';

export default function SkuLayout({
  children,
  skuName,
  country,
  category,
  description_language,
  windowTitle,
}: SkuLayoutProps) {
  const router = useRouter();
  const { locale, asPath } = router;

  const canonicalPath = locale === 'en' ? asPath : `/${locale}${asPath}`;
  const canonicalUrl = `https://spiritory.com${canonicalPath}`;

  return (
    <>
      <Head>
        <title>{windowTitle}</title>
        <meta
          name="description"
          content={`${description_language[0]} ${skuName} ${description_language[1]} ${country} ${description_language[2]} ${category}s ${description_language[3]}`}
        />
        <meta name="keywords" content={`${skuName}, ${country}, ${category}`} />
        <link rel="canonical" href={canonicalUrl} />

        <SEO_Cookiebot />
      </Head>
      {children}
    </>
  );
}
